import type { Translation } from '../../types';
import type { catalog as en } from '../en/catalog';

/** Danh mục sản phẩm (Sản phẩm & giá): sản phẩm, gói, giá theo chu kỳ, cấp phát, tồn kho, quá hạn. Lời thường. */
export const catalog: Translation<typeof en> = {
  crumb: 'Sản phẩm & giá',
  title: 'Danh mục sản phẩm',
  subtitle: 'Những gì Tino bán ngoài tên miền: hosting, máy chủ ảo, email, website, máy chủ, bản quyền phần mềm và SSL. Mỗi gói bắt đầu là bản nháp và chỉ được mở bán khi đã có giá, tồn kho và (với sản phẩm cấp tự động) cách cấp phát.',
  groups: 'Nhóm sản phẩm',
  allGroups: 'Tất cả nhóm',
  noProducts: 'Nhóm này chưa có sản phẩm nào.',
  productCount_one: '{{count}} sản phẩm',
  productCount_other: '{{count}} sản phẩm',
  onSale_one: '{{count}} gói đang bán',
  onSale_other: '{{count}} gói đang bán',
  back: 'Về danh mục',
  backToProduct: 'Về sản phẩm',
  draftNotice: 'Gói đang là bản nháp thì chưa bán: khách không nhìn thấy.',
  fourEyesNotice: 'Đây là hệ thống thật: mở bán một gói và công bố giá mới cần một người thứ hai duyệt.',
  approvalRequested: 'Đã gửi đề nghị duyệt. Khi một người khác đồng ý (Trang chủ › Phê duyệt), anh/chị làm lại đúng thao tác này để áp dụng.',
  applied: 'Đã xong.',
  applyApproved: 'Áp dụng (đã có người thứ hai duyệt)',
  col: {
    product: 'Sản phẩm',
    group: 'Nhóm',
    delivery: 'Cấp phát',
    plans: 'Số gói',
    visibility: 'Trạng thái',
    plan: 'Gói',
    cycles: 'Chu kỳ thanh toán',
    tax: 'VAT',
    fromPrice: 'Giá từ',
    ready: 'Sẵn sàng bán',
  },
  visibility: { DRAFT: 'Bản nháp', PUBLIC: 'Đang bán', HIDDEN: 'Đã ẩn (chỉ gia hạn)', RETIRED: 'Đã ngừng' },
  fulfilment: { PROVISIONED: 'Tự động (qua module)', MANUAL: 'Nhân viên cấp thủ công' },
  branch: { dns: 'DNS', hosting: 'Hosting', email: 'Email', cloud: 'Máy chủ ảo', website: 'Website' },
  serviceLabel: { DOMAIN: 'Gọi theo tên miền', HOSTNAME: 'Gọi theo tên máy', NONE: 'Không cần tên' },
  saleMode: { CYCLE: 'Theo chu kỳ', HOURLY: 'Theo giờ' },
  cycle: { ONCE: 'Một lần', H1: '1 giờ', M1: '1 tháng', M3: '3 tháng', M6: '6 tháng', M12: '1 năm', M24: '2 năm', M36: '3 năm', M48: '4 năm', M60: '5 năm' },
  discount: '−{{pct}}%',
  tax: { VAT8: 'VAT 8%', VAT10: 'VAT 10%', KCT: 'Không chịu VAT' },
  problem: {
    NO_STOCK: 'Chưa có nơi nào bán được (hết hàng hoặc đã đóng)',
    NO_FULFILMENT: 'Chưa đặt kết nối module: module, nhóm máy chủ và gói bên nhà cung cấp',
    NO_ACCEPTING_MEMBER: 'Nhóm máy chủ không còn máy nào của module này nhận dịch vụ mới',
    PLACEMENT_BRANCH_MISMATCH: 'Nhóm máy chủ dành cho loại sản phẩm khác',
    PRODUCT_RETIRED: 'Sản phẩm đã ngừng',
    NO_RETAIL_BOOK: 'Chưa có bảng giá khách lẻ nào đang dùng',
    NO_PRICE: 'Thiếu giá của một chu kỳ',
    NO_TAX_RATE: 'Thuế suất VAT của gói chưa có hiệu lực',
    NO_TAX_CODE: 'Gói và nhóm của gói đều chưa có thuế suất VAT',
    SALE_MODE_MISMATCH: 'Chu kỳ của gói không hợp với cách bán của nhóm',
  },
  productTabs: { info: 'Thông tin', plans: 'Gói', options: 'Tuỳ chọn cấu hình', addons: 'Add-on', domains: 'Tên miền', lifecycle: 'Quá hạn & gia hạn', history: 'Lịch sử' },
  planTabs: { specs: 'Thông số', prices: 'Giá theo chu kỳ', pricesHourly: 'Giá theo giờ', delivery: 'Kết nối module', stock: 'Tồn kho & vị trí', domains: 'Tên miền tặng', alongside: 'Bán kèm' },
  info: {
    code: 'Mã',
    group: 'Nhóm',
    fulfilment: 'Cách cấp',
    branch: 'Loại dịch vụ',
    label: 'Dịch vụ được gọi',
    trial: 'Dùng thử miễn phí',
    trialDays_one: '{{count}} ngày',
    trialDays_other: '{{count}} ngày',
    moneyBack: 'Thời hạn hoàn tiền',
    none: 'Không có',
  },
  plans: {
    empty: 'Sản phẩm này chưa có gói nào.',
    notReady: 'Chưa bán được vì:',
    ready: 'Sẵn sàng bán',
    publish: 'Mở bán',
    unpublish: 'Ngừng bán',
    retire: 'Ngừng hẳn',
    publishTitle: 'Mở bán {{plan}}',
    unpublishTitle: 'Ngừng bán {{plan}}',
    publishDescription: 'Khi đang bán, khách đặt mua được gói theo giá của nó. Gói ngừng bán vẫn gia hạn được cho các dịch vụ đã mua.',
    newPlan: 'Thêm gói',
    taxFromGroup: 'theo nhóm',
    noTax: 'Chưa có thuế suất',
  },
  options: {
    empty: 'Không có tuỳ chọn cấu hình: khách chỉ chọn chu kỳ thanh toán.',
    kind: { SELECT: 'Chọn một (danh sách)', RADIO: 'Chọn một (nút)', CHECKBOX: 'Ô đánh dấu', QUANTITY: 'Số lượng', TEXT: 'Nhập chữ', SSH_KEY: 'Khoá SSH', HIDDEN: 'Lấy từ trang sản phẩm' },
    required: 'Bắt buộc',
    changeable: 'Đổi được sau khi mua',
    mapsTo: 'Thông số nhận:',
    default: 'mặc định',
    free: 'miễn phí',
    condition: 'Khi {{group}} là {{items}}: {{targets}} {{effect}}',
    effect: { HIDE: 'không được chọn', REQUIRE: 'bắt buộc chọn' },
    price: '{{amount}} đ / {{cycle}}',
    setup: 'phí khởi tạo {{amount}} đ',
    percent: '+{{pct}}% giá theo giờ',
    standardKinds: 'Kiểu chuẩn',
    moduleKinds: 'Của {{module}}',
    mapsToNone: 'Không: chỉ ảnh hưởng tới giá',
    toGroup: '→ nhóm máy chủ {{group}}',
  },
  optionKey: {
    dedicated_ip: 'Địa chỉ IP riêng',
    image: 'Mẫu cài hệ điều hành',
    ssh_keys: 'Khoá SSH',
    ipv4: 'Thêm địa chỉ IPv4',
    ipv6: 'Địa chỉ IPv6',
    template: 'Mẫu website',
  },
  addons: {
    empty: 'Sản phẩm này không có add-on.',
    billing: { RECURRING: 'Tính cùng dịch vụ', ONCE: 'Một lần' },
    noPrice: 'Chưa có giá',
  },
  lifecycle: {
    title: 'Quá hạn & gia hạn',
    intro: 'Giống HostBill và WHMCS, mỗi sản phẩm có cài đặt riêng. Ô nào để trống thì lấy theo nhóm, rồi theo mặc định của hệ thống.',
    invoice_days_before: 'Tạo đơn gia hạn (kèm QR)',
    reminder_days: 'Nhắc thanh toán',
    payment_due_days_before: 'Hạn thanh toán ghi trên thông báo',
    suspend: 'Tạm ngưng (khoá) dịch vụ',
    terminate: 'Huỷ dịch vụ',
    keep_backups_days: 'Giữ bản sao lưu cuối',
    late_fee: 'Phí trả chậm',
    auto_debit_wallet: 'Tự trừ ví để gia hạn khi ví đủ tiền',
    daysBefore_one: 'trước ngày hết hạn {{count}} ngày',
    daysBefore_other: 'trước ngày hết hạn {{count}} ngày',
    daysOverdue_one: 'quá hạn {{count}} ngày',
    daysOverdue_other: 'quá hạn {{count}} ngày',
    days_one: '{{count}} ngày',
    days_other: '{{count}} ngày',
    off: 'Không',
    on: 'Có',
    noLateFee: 'Không thu',
    lateFee: '{{pct}}% đơn gia hạn, khi quá hạn {{days}} ngày',
    source: { PRODUCT: 'sản phẩm này', GROUP: 'nhóm', GLOBAL: 'mặc định hệ thống' },
    from: 'theo {{source}}',
    calendar: 'Lịch (tính từ ngày hết hạn)',
    day: 'Ngày',
    event: { RENEWAL_ORDER: 'Tạo đơn gia hạn, gửi QR', REMINDER: 'Nhắc thanh toán', LATE_FEE: 'Cộng phí trả chậm', SUSPEND: 'Tạm ngưng dịch vụ', TERMINATE: 'Huỷ dịch vụ, xoá dữ liệu' },
    dueDay: 'ngày hết hạn',
    edit: 'Đổi cho sản phẩm này',
    editTitle: 'Quá hạn & gia hạn của {{product}}',
    emptyInherits: 'Để trống một ô để giữ giá trị của nhóm hoặc của hệ thống.',
    reminderHint: 'Số ngày trước ngày hết hạn, cách nhau bằng dấu phẩy; 0 là đúng ngày hết hạn, −3 là quá hạn 3 ngày.',
    problem: {
      terminateBeforeSuspend: 'Ngày huỷ phải sau ngày tạm ngưng.',
      payByBeforeOrder: 'Hạn thanh toán không được trước ngày tạo đơn gia hạn.',
      reminderBeforeOrder: 'Không nhắc thanh toán trước ngày tạo đơn gia hạn.',
    },
  },
  history: { empty: 'Chưa có thay đổi nào.', what: 'Nội dung', who: 'Người làm', why: 'Lý do', when: 'Lúc', system: 'Hệ thống' },
  specs: { empty: 'Chưa có thông số.' },
  prices: {
    intro: 'Giá chưa gồm VAT, cho trọn một chu kỳ. Giá mới áp dụng từ thời điểm anh/chị chọn; báo giá đã đưa giữ nguyên giá cũ. Gia hạn tính theo giá đang áp dụng vào ngày gia hạn.',
    introHourly: 'Giá chưa gồm VAT, cho một giờ, không có phí khởi tạo. Giá mới áp dụng từ thời điểm anh/chị chọn; báo giá đã đưa giữ nguyên giá cũ.',
    book: 'Bảng giá',
    current: 'Đang áp dụng',
    next: 'Từ {{date}}: {{amount}} đ',
    none: 'Chưa có giá',
    setup: 'Phí khởi tạo {{amount}} đ',
    edit: 'Đặt giá mới',
    editTitle: 'Giá mới của {{plan}}',
    from: 'Áp dụng từ',
    fromHint: 'Để trống: ngay bây giờ. Giá mới không bao giờ sửa quá khứ.',
    amount: 'Giá trọn chu kỳ (đ, chưa VAT)',
    setupFee: 'Phí khởi tạo (đ)',
    hourly: 'Giá theo giờ',
    hourlyAmount: 'Giá một giờ (đ, chưa VAT)',
    unreadable: 'Nhập số đồng, ví dụ 758.400.',
    bookKind: { TIER: 'Theo hạng', CUSTOMER_CONTRACT: 'Giá riêng khách hàng' },
  },
  delivery: {
    manual: 'Nhân viên cấp sản phẩm này bằng tay: không gọi module nào.',
    none: 'Chưa đặt kết nối module.',
    module: 'Module',
    group: 'Nhóm máy chủ',
    providerPlan: 'Gói bên nhà cung cấp',
    providerPlanHint: 'Gói WHM, cấu hình (flavor) Proxmox hoặc gói WildDuck.',
    providerPlanListed: 'Đọc từ mọi máy chủ đang nhận dịch vụ mới của nhóm: gói thiếu ở một máy thì không chọn được.',
    noProviderPlan: 'Không có (module không có danh sách gói)',
    template: 'Mẫu cài sẵn',
    templateHint: 'Chỉ khi gói luôn cài một ứng dụng (VPS ứng dụng).',
    overrides: 'Tham số riêng của gói',
    noOverrides: 'Tất cả theo nhóm máy chủ',
    noModuleAccess: 'Cần quyền xem cài đặt module để thấy các kết nối: gói và tham số được nhập tay, và được kiểm khi lưu.',
    noGroup: 'Chưa có nhóm máy chủ nào của module này: thêm ở Nhóm máy chủ.',
    settingsHint: 'Để trống: lấy giá trị của nhóm máy chủ. Chỉ nhập ở tham số mà gói này khác nhóm.',
    step: { module: '1. Module', group: '2. Nhóm máy chủ', plan: '3. Gói bên nhà cung cấp', settings: '4. Tham số cấp phát của gói' },
    edit: 'Sửa kết nối module',
    editTitle: 'Kết nối module của {{plan}}',
    accepting: 'Đang nhận dịch vụ mới',
    notAccepting: 'Không nhận dịch vụ mới',
  },
  stock: {
    none: 'Chưa có vị trí nào: gói chưa bán được.',
    location: 'Vị trí',
    mode: { UNLIMITED: 'Không giới hạn', COUNTED: 'Theo số lượng', CAPACITY: 'Khi máy chủ còn chỗ', CLOSED: 'Hết hàng' },
    left: 'còn {{left}} / {{quantity}}',
    customerChoice: 'Khách được chọn vị trí này',
    edit: 'Đổi',
    editTitle: 'Tồn kho của {{plan}} tại {{location}}',
    quantity: 'Số lượng',
    add: 'Thêm vị trí',
  },
  domains: {
    none: 'Gói này không tặng tên miền.',
    rule: 'Tặng .{{zone}} khi mua từ {{cycle}}',
    renewals: 'miễn phí cả khi gia hạn',
    firstTerm: 'chỉ năm đầu',
  },
  alongside: { none: 'Không bán kèm gì.', intro: 'Gợi ý trong giỏ hàng bên cạnh gói này; mỗi món là một dịch vụ riêng.' },
  domainOptions: {
    intro: 'Như tab Domains của HostBill: dịch vụ dùng tên miền nào. Hiện chỉ “Tên miền khách đã có” và “Chỉ tên miền đăng ký tại Tino” có tác dụng (khi nhân viên tạo dịch vụ); các mục khác được lưu để dùng khi có giỏ hàng.',
    edit: 'Sửa',
    editTitle: 'Tên miền của {{product}}',
    own: 'Tên miền khách đã có',
    ownAny: 'Mọi tên miền',
    ownHere: 'Chỉ tên miền đăng ký tại Tino',
    register: 'Đăng ký mới',
    transfer: 'Chuyển về Tino',
    tlds: 'Đuôi được mời',
    allTlds: 'Mọi đuôi đang bán',
    subdomain: 'Tên miền con miễn phí',
    free: 'Tên miền tặng theo gói',
    freeIntro: 'Mỗi gói đặt tên miền tặng ở tab “Tên miền tặng” của gói.',
  },
  order: {
    button: 'Tạo dịch vụ',
    title: 'Tạo dịch vụ cho {{customer}}',
    description: 'Đặt đơn một gói đang bán theo giá của khách. Tiền được giữ trên ví của khách; dịch vụ được cấp phát, hoá đơn lập sau khi dịch vụ kích hoạt thành công.',
    product: 'Sản phẩm',
    plan: 'Gói',
    cycle: 'Chu kỳ',
    location: 'Vị trí',
    domain: 'Tên miền của dịch vụ',
    domainHint: 'Tên miền gắn với tài khoản hosting, website, email hoặc vùng DNS.',
    username: 'Tên đăng nhập cPanel',
    usernameHint: 'Không bắt buộc: tên được kiểm ngay theo quy tắc của máy chủ hosting (với cPanel: tối đa 8 chữ thường và số, bắt đầu bằng chữ cái, không bắt đầu bằng "test", không dùng tên dành riêng) và không trùng tài khoản đã có. Để trống thì hệ thống tạo từ tên miền.',
    usernameChecking: 'Đang kiểm tên đăng nhập trên kết nối hosting của gói…',
    label: 'Tên dịch vụ',
    labelHint: 'Không bắt buộc; giúp khách và nhân viên nhận ra dịch vụ.',
    promotion: 'Mã khuyến mãi',
    choose: 'Chọn…',
    price: 'Xem giá',
    total: 'Tổng {{total}} (trong đó VAT {{tax}})',
    walletNote: 'Đơn trừ vào ví của {{customer}}. Ví không đủ thì đơn bị từ chối và báo số tiền cần nạp thêm.',
    submit: 'Tạo đơn và trừ ví',
    placed: 'Đã tạo đơn {{description}}, giữ {{total}} trên ví. Dịch vụ đang được cấp phát.',
    options: 'Tuỳ chọn cấu hình',
    optionDefault: 'Mặc định: {{item}}',
    optionHidden: '{{item}} (chỉ nhân viên)',
    quantityHint: 'Từ {{min}} đến {{max}}; để trống: {{min}}.',
  },
  servers: {
    members: 'Máy chủ của nhóm',
    membersTitle: 'Máy chủ của {{group}}',
    noMembers: 'Nhóm chưa có máy chủ nào: gói cấp tại đây chưa tạo được dịch vụ mới.',
    add: 'Thêm máy chủ',
    addButton: 'Thêm',
    chooseConnection: 'Chọn kết nối module',
    serverHint: 'Tên máy chủ hoặc node trong kết nối (hosting, máy chủ ảo); để trống nếu kết nối tự chọn.',
    remove: 'Gỡ khỏi nhóm',
    duplicate: 'Máy chủ này đã có trong nhóm.',
    title: 'Nhóm máy chủ',
    subtitle: 'Nơi tạo dịch vụ mới của một gói: các kết nối module và, với hosting và máy chủ ảo, các máy chủ hoặc node của chúng.',
    empty: 'Chưa có nhóm máy chủ nào.',
    strategy: { LEAST_USED: 'Máy ít dùng nhất trước', FILL_FIRST: 'Lấp đầy từng máy', FIXED: 'Luôn một máy' },
    instance: 'Kết nối',
    server: 'Máy chủ',
    weight: 'Trọng số',
    plans_one: '{{count}} gói cấp tại đây',
    plans_other: '{{count}} gói cấp tại đây',
    location: 'Vị trí',
    toggle: 'Ngừng / nhận lại dịch vụ mới',
    toggleTitle: 'Máy chủ của {{group}} nhận dịch vụ mới',
    moduleLocked: 'Nhóm đã có máy chủ hoặc gói: không đổi được module.',
    noServerData: 'Kết nối chưa báo số liệu máy chủ: làm mới danh sách máy chủ của kết nối, hoặc để trống cho kết nối tự chọn.',
    defaults: 'Tham số cấp phát của nhóm',
    defaultsHint: 'Mọi gói của nhóm dùng các giá trị này; gói chỉ ghi đè được những tham số cho phép.',
  },
  fulfil: {
    title: 'Sẵn sàng bán',
    intro: 'Các máy chủ có nhận được gói này không: kiểm theo số liệu đã đọc lần trước khi lưu và khi mở bán.',
    check: 'Kiểm tra',
    checkLive: 'Kiểm tra ngay',
    checked: { CACHED: 'Kiểm theo số liệu đã đọc từ máy chủ, lúc {{when}}.', LIVE: 'Kiểm bằng cách hỏi từng máy chủ, lúc {{when}}.' },
    ready: 'Sẵn sàng',
    notReady: 'Chưa sẵn sàng',
    state: { OK: 'Đạt', WARN: 'Cảnh báo', BLOCK: 'Chặn mở bán' },
    condition: {
      module: 'Nhóm máy chủ đúng module',
      members: 'Nhóm có kết nối, kết nối đang bật',
      facts: 'Số liệu từ máy chủ',
      plan: 'Gói có trên mọi máy chủ',
      settings: 'Tham số cấp phát',
      options: 'Giá trị tuỳ chọn cấu hình có trên máy chủ',
      capacity: 'Máy chủ còn chỗ',
    },
    problem: {
      GROUP_MODULE_MISMATCH: 'Nhóm máy chủ dùng module khác',
      MEMBER_NOT_FOUND: 'Một kết nối của nhóm không còn',
      MEMBER_DISABLED: 'Một kết nối của nhóm đang tắt',
      FIXED_NEEDS_ONE: '“Luôn một máy” cần đúng một máy chủ đang nhận dịch vụ mới',
      FACTS_MISSING: 'Chưa đọc số liệu từ máy chủ này: bấm Làm mới ở nhóm máy chủ',
      FACTS_STALE: 'Số liệu của máy chủ này đã cũ hơn 24 giờ',
      NO_SERVER_DATA: 'Máy chủ chưa báo số tài khoản',
      NOT_SENT: 'Không kết nối được tới máy chủ: chưa hỏi được gì',
      UNKNOWN: 'Máy chủ không trả lời kịp',
      REFUSED: 'Máy chủ từ chối lệnh đọc (lý do ở sau)',
      PLAN_NOT_FOUND: 'Máy chủ này không có gói',
      SETTINGS_INVALID: 'Tham số sau khi gộp với nhóm không hợp lệ với module',
      NOT_OVERRIDABLE: 'Gói ghi đè một tham số không được phép',
      VALUE_NOT_FOUND: 'Một giá trị của tuỳ chọn cấu hình không có trên máy chủ này',
      NO_CAPACITY: 'Máy chủ hết chỗ cho tài khoản mới',
    },
    fix: { edit: 'Sửa', group: 'Mở nhóm máy chủ', options: 'Mở tuỳ chọn cấu hình' },
  },
  connection: {
    instance: 'Kết nối',
    server: 'Máy chủ',
    anyServer: 'Kết nối tự chọn',
    state: 'Trạng thái',
    accounts: 'Tài khoản / sức chứa',
    accountsOf: '{{accounts}} / {{max}}',
    accountsFull: '{{accounts}} · đầy',
    serverDown: 'máy không phản hồi',
    facts: 'Số liệu từ máy chủ',
    factsAge: 'đọc {{age}}',
    noFacts: 'chưa có số liệu',
    factsError: 'không đọc được',
    refresh: 'Làm mới',
    choose: 'Chọn…',
    missingOn: 'thiếu ở {{servers}}',
    notListed: '{{value}} (máy chủ không có)',
    noList: 'Chưa có danh sách: bấm Làm mới ở nhóm máy chủ, hoặc kiểm tra nhóm còn kết nối nhận dịch vụ mới.',
    fromGroup: 'Theo nhóm',
    fromGroupValue: 'Theo nhóm: {{value}}',
    notOverridable: 'Gói không ghi đè được tham số này: luôn theo nhóm máy chủ.',
    yes: 'Có',
    no: 'Không',
  },
  locations: {
    title: 'Vị trí',
    subtitle: 'Các trung tâm dữ liệu nơi gói được bán.',
    empty: 'Chưa có vị trí nào.',
    code: 'Mã',
    name: 'Tên',
    city: 'Thành phố',
    active: 'Đang dùng',
    inactive: 'Không dùng',
    add: 'Thêm vị trí',
  },
  quote: {
    title: 'Tính thử dịch vụ',
    subtitle: 'Giá của một gói theo chu kỳ, từng dòng kèm VAT, đúng như khách sẽ trả. Không lưu lại gì.',
    product: 'Sản phẩm',
    plan: 'Gói',
    cycle: 'Chu kỳ thanh toán',
    book: 'Bảng giá',
    action: 'Cho',
    new: 'Dịch vụ mới',
    renew: 'Gia hạn',
    promotion: 'Mã khuyến mãi',
    run: 'Tính giá',
    line: 'Dòng',
    amount: 'Thành tiền',
    vat: 'VAT',
    total: 'Tổng',
    subtotal: 'Chưa VAT',
    payToday: 'Thanh toán hôm nay',
    renewal: 'Lần gia hạn tới (chưa VAT, theo giá hôm nay)',
    discount: 'giảm {{amount}} đ',
    kind: { PLAN: 'Gói', SETUP: 'Phí khởi tạo', OPTION: 'Tuỳ chọn', ADDON: 'Add-on' },
    pick: 'Chọn sản phẩm và gói.',
  },
  editor: {
    noTaxRate: 'Chưa có thuế suất nào: thêm ở Giá → Thuế suất',
    groupTaxNone: 'Chưa đặt',
    taxFromGroup: 'Theo nhóm ({{tax}})',
    saleModeLocked: 'Nhóm đã có sản phẩm: không đổi được cách bán.',
    hourlyPlan: 'Nhóm bán theo giờ: gói có một giá theo giờ. Gói báo giá được, chưa đặt đơn được.',
    unreadablePercent: 'Nhập phần trăm, ví dụ 5 hoặc 12,5.',
    taxRateMissing: 'không còn thuế suất',
    newGroup: 'Thêm nhóm',
    newGroupTitle: 'Nhóm sản phẩm mới',
    editGroup: 'Sửa nhóm',
    editGroupTitle: 'Sửa nhóm {{group}}',
    newProduct: 'Thêm sản phẩm',
    newProductTitle: 'Sản phẩm mới',
    editProduct: 'Sửa sản phẩm',
    editProductTitle: 'Sửa {{product}}',
    productVisibility: 'Hiện / ẩn',
    productVisibilityTitle: 'Hiện hoặc ẩn {{product}}',
    productVisibilityIntro: 'Sản phẩm chỉ hiện trong danh mục khi có ít nhất một gói đang bán. Muốn ngừng hẳn sản phẩm thì ngừng bán các gói của nó trước.',
    newPlanTitle: 'Gói mới của {{product}}',
    editPlan: 'Sửa gói',
    editPlanTitle: 'Sửa {{plan}}',
    addSpec: 'Thêm dòng',
    remove: 'Bỏ',
    newOptionGroup: 'Thêm tuỳ chọn',
    newOptionGroupTitle: 'Tuỳ chọn cấu hình mới của {{product}}',
    editOptionGroup: 'Sửa',
    editOptionGroupTitle: 'Sửa {{group}}',
    addCondition: 'Thêm điều kiện',
    noConditions: 'Không có điều kiện: lựa chọn ở đây không phụ thuộc lựa chọn nào khác.',
    conditionSentence: 'Khi khách chọn {{items}} ở {{group}}, các lựa chọn sau ở đây {{effect}}: {{targets}}',
    anyItem: 'bất kỳ lựa chọn nào',
    newItem: 'Thêm lựa chọn',
    newItemTitle: 'Lựa chọn mới trong {{group}}',
    editItem: 'Sửa',
    editItemTitle: 'Sửa {{item}}',
    setPrice: 'Đặt giá',
    optionPriceTitle: 'Giá của {{item}}',
    addonPriceTitle: 'Giá của {{addon}}',
    perUnit: 'Với tuỳ chọn số lượng, giá tính cho mỗi đơn vị.',
    newAddon: 'Thêm add-on',
    newAddonTitle: 'Add-on mới',
    editAddon: 'Sửa',
    editAddonTitle: 'Sửa {{addon}}',
    editCrossSells: 'Sửa gợi ý bán kèm',
    crossSellsTitle: 'Bán kèm {{plan}}',
    editFreeDomains: 'Sửa tên miền tặng',
    freeDomainsTitle: 'Tên miền tặng kèm {{plan}}',
    addFreeDomain: 'Thêm đuôi tên miền',
    endPrice: 'Ngừng một mức giá',
    endPriceTitle: 'Ngừng một mức giá của {{plan}}',
    endPriceRow: '{{book}} · {{cycle}} · {{amount}} đ',
    endPriceNone: 'Không có mức giá nào để ngừng.',
    addStock: 'Thêm vị trí',
    addStockTitle: 'Bán {{plan}} ở vị trí khác',
    clearLifecycle: 'Lấy lại theo nhóm',
    clearLifecycleTitle: 'Quá hạn & gia hạn của {{product}} theo nhóm',
    clearLifecycleIntro: 'Bỏ mọi cài đặt riêng của sản phẩm này: sản phẩm theo cài đặt của nhóm, rồi theo mặc định của hệ thống.',
    editLocation: 'Sửa',
    editLocationTitle: 'Sửa {{location}}',
    newServerGroup: 'Thêm nhóm máy chủ',
    editServerGroup: 'Sửa',
    editServerGroupTitle: 'Sửa {{group}}',
    none: '— Không chọn —',
    allPlans: 'Mọi gói của sản phẩm',
    anyCycle: 'Mọi chu kỳ',
    codeInvalid: 'Chỉ dùng chữ thường không dấu, số và dấu gạch ngang.',
    unreadable: 'Nhập số đồng, ví dụ 758.400.',
    cyclesProblem: { none: 'Chọn ít nhất một chu kỳ thanh toán.', onceAlone: 'Gói trả một lần thì không bán chu kỳ nào khác.', hourAlone: 'Gói theo giờ thì không bán chu kỳ nào khác.' },
    conditionProblem: {
      unknownGroup: 'Một điều kiện nhắc tới tuỳ chọn mà sản phẩm không có.',
      noTrigger: 'Mỗi điều kiện cần ít nhất một lựa chọn kích hoạt.',
      badEffect: 'Mỗi điều kiện cần nói rõ điều gì xảy ra.',
    },
    quantityProblem: 'Số nhỏ nhất không được lớn hơn số lớn nhất.',
    itemVisibility: { PUBLIC: 'Khách chọn được', HIDDEN: 'Ẩn (chỉ nhân viên chọn)', RETIRED: 'Ngừng dùng' },
    addonFulfilment: { MODULE_OP: 'Hệ thống tự làm trên dịch vụ', MANUAL: 'Nhân viên làm', NONE: 'Không cần làm gì' },
    freeOperation: { REGISTER: 'Đăng ký mới', TRANSFER: 'Chuyển về Tino' },
    field: {
      code: { label: 'Mã', help: 'Chữ thường không dấu, số và dấu gạch ngang. Đặt một lần, không đổi được: mã xuất hiện trong đường dẫn và báo cáo.' },
      optionCode: { label: 'Mã', help: 'Chữ thường không dấu, số, gạch ngang và gạch dưới. Đặt một lần, không đổi được.' },
      nameVi: { label: 'Tên tiếng Việt', help: 'Khách thấy tên này trên trang tiếng Việt và trên hoá đơn.' },
      nameEn: { label: 'Tên tiếng Anh', help: 'Khách thấy tên này trên trang tiếng Anh. Để trống thì dùng tên tiếng Việt.' },
      descriptionVi: { label: 'Mô tả tiếng Việt', help: 'Một câu ngắn hiện dưới tên. Không bắt buộc.' },
      descriptionEn: { label: 'Mô tả tiếng Anh', help: 'Câu mô tả bằng tiếng Anh. Không bắt buộc.' },
      sort: { label: 'Thứ tự hiển thị', help: 'Số nhỏ đứng trước.' },
      group: { label: 'Nhóm sản phẩm', help: 'Ô nhóm mà sản phẩm được xếp vào.' },
      fulfilment: { label: 'Cách cấp dịch vụ', help: 'Tự động qua hệ thống đã kết nối, hoặc nhân viên cấp bằng tay.' },
      branch: { label: 'Loại dịch vụ', help: 'Quyết định hệ thống và nhóm máy chủ nào cấp được. Không đổi được khi sản phẩm đã có gói.' },
      serviceLabel: { label: 'Dịch vụ được gọi theo', help: 'Điều khách nhập khi mua: tên miền, tên máy chủ, hoặc không cần gì.' },
      trialDays: { label: 'Dùng thử miễn phí (ngày)', help: 'Từ 1 đến 30 ngày. Để trống: không cho dùng thử.' },
      moneyBackDays: { label: 'Thời hạn hoàn tiền (ngày)', help: 'Từ 1 đến 90 ngày. Để trống: không hoàn tiền.' },
      productVisibility: { label: 'Trạng thái', help: 'Hiện, ẩn (dịch vụ đã mua vẫn gia hạn được) hoặc ngừng hẳn.' },
      cycles: { label: 'Chu kỳ thanh toán được bán', help: 'Mỗi chu kỳ cần có giá khách lẻ trước khi mở bán gói.' },
      taxCode: { label: 'Thuế suất VAT', help: 'Thuế suất in trên hoá đơn của add-on này.' },
      saleMode: { label: 'Cách bán', help: 'Theo chu kỳ (tháng, năm) hoặc theo giờ. Không đổi được khi nhóm đã có sản phẩm.' },
      groupTax: { label: 'Thuế suất VAT của nhóm', help: 'Gói không chọn thuế riêng thì dùng thuế này. Không đổi được khi còn gói đang dùng: đặt thuế riêng cho các gói đó trước.' },
      planTax: { label: 'Thuế suất VAT', help: 'Theo nhóm: gói dùng thuế của nhóm. Chỉ chọn mã khi gói cần thuế riêng.' },
      pricePercent: { label: 'Cộng thêm (%)', help: 'Phần trăm của giá theo giờ của gói, tính trước khuyến mãi. Ví dụ 5 hoặc 12,5.' },
      upgradesTo: { label: 'Nâng cấp lên được', help: 'Các gói cùng sản phẩm mà khách được chuyển lên.' },
      specs: { label: 'Thông số', help: 'Các dòng hiện trong bảng giá, theo thứ tự này.' },
      specLabelVi: { label: 'Tên (tiếng Việt)', help: 'Ví dụ “Dung lượng NVMe”.' },
      specLabelEn: { label: 'Tên (tiếng Anh)', help: 'Ví dụ “NVMe storage”.' },
      specValue: { label: 'Giá trị', help: 'Ví dụ “5 GB”.' },
      specUnit: { label: 'Đơn vị', help: 'Không bắt buộc, hiện sau giá trị.' },
      optionKind: { label: 'Kiểu trường', help: 'Kiểu chuẩn, hoặc kiểu riêng của module mà các gói dùng. Không đổi được về sau: muốn khác thì tạo tuỳ chọn mới.' },
      required: { label: 'Khách bắt buộc chọn', help: 'Bỏ đánh dấu: khách được để trống.' },
      minQty: { label: 'Số nhỏ nhất', help: 'Số lượng ít nhất khách được đặt.' },
      maxQty: { label: 'Số lớn nhất', help: 'Số lượng nhiều nhất khách được đặt.' },
      step: { label: 'Mỗi bước', help: 'Ví dụ 1, hoặc 2 nếu bán theo cặp. Để trống: 1.' },
      changeable: { label: 'Đổi được sau khi mua', help: 'Khách đổi được lựa chọn này khi dịch vụ đang chạy.' },
      mapsTo: { label: 'Thông số nhận lựa chọn khi tạo dịch vụ', help: 'Thông số chuẩn của loại dịch vụ, hoặc tham số cấp phát của module mà các gói dùng. Không chọn: lựa chọn chỉ ảnh hưởng tới giá.' },
      optionPlans: { label: 'Áp dụng cho gói', help: 'Không đánh dấu gói nào: áp dụng cho mọi gói của sản phẩm.' },
      conditions: { label: 'Điều kiện', help: 'Lựa chọn ở tuỳ chọn khác có thể ẩn bớt lựa chọn ở đây hoặc bắt buộc chọn một trong số đó.' },
      whenGroup: { label: 'Khi khách chọn ở', help: 'Một tuỳ chọn khác của cùng sản phẩm.' },
      whenItems: { label: 'một trong các lựa chọn', help: 'Ít nhất một.' },
      effect: { label: 'thì ở đây', help: 'Lựa chọn bị ẩn thì không chọn được; bắt buộc thì phải chọn.' },
      effectItems: { label: 'các lựa chọn', help: 'Không đánh dấu gì khi “bắt buộc chọn”: bất kỳ lựa chọn nào của tuỳ chọn này.' },
      itemProviderValue: { label: 'Giá trị gửi khi tạo dịch vụ', help: 'Ví dụ tên mẫu cài đặt của hệ điều hành. Để trống: không gửi gì.' },
      itemServerValue: { label: 'Giá trị trên máy chủ', help: 'Đúng như máy chủ liệt kê; được kiểm trên mọi máy chủ của nhóm khi lưu.' },
      itemPlacementGroup: { label: 'Nhóm máy chủ', help: 'Dịch vụ có lựa chọn này được tạo ở nhóm này. Chỉ các nhóm cùng module.' },
      itemDefault: { label: 'Chọn sẵn', help: 'Mỗi tuỳ chọn chỉ có một lựa chọn chọn sẵn: đánh dấu ở đây sẽ bỏ ở lựa chọn khác.' },
      itemVisibility: { label: 'Trạng thái', help: 'Lựa chọn ẩn chỉ nhân viên chọn được; lựa chọn ngừng dùng thì không ai chọn được.' },
      addonBilling: { label: 'Cách tính tiền', help: 'Tính cùng dịch vụ mỗi chu kỳ, hoặc thu một lần.' },
      addonFulfilment: { label: 'Khi khách mua thì', help: 'Hệ thống tự làm trên dịch vụ, nhân viên làm, hoặc không cần làm gì.' },
      addonAction: { label: 'Việc hệ thống tự làm', help: 'Việc làm trên dịch vụ khi khách mua, ví dụ bật sao lưu.' },
      addonProducts: { label: 'Bán kèm sản phẩm', help: 'Khách của các sản phẩm này mua thêm được add-on.' },
      addonVisibility: { label: 'Trạng thái', help: 'Chỉ add-on “Đang bán” mới mua được.' },
      priceBook: { label: 'Bảng giá', help: 'Giá của một hạng cho mọi sản phẩm, hoặc giá riêng của một khách hàng.' },
      priceFrom: { label: 'Áp dụng từ', help: 'Để trống: ngay bây giờ. Giá mới không bao giờ sửa quá khứ.' },
      priceAmount: { label: 'Giá mỗi chu kỳ (đ, chưa VAT)', help: 'Số đồng; 0 là miễn phí.' },
      setupFee: { label: 'Phí khởi tạo (đ)', help: 'Thu một lần, cùng chu kỳ đầu.' },
      upgradeFee: { label: 'Phí chọn thêm về sau (đ)', help: 'Thu khi dịch vụ đang chạy chuyển sang lựa chọn này.' },
      downgradeFee: { label: 'Phí bỏ lựa chọn (đ)', help: 'Thu khi dịch vụ đang chạy bỏ lựa chọn này.' },
      crossSellPlans: { label: 'Gợi ý trong giỏ hàng', help: 'Gói của sản phẩm khác, gợi ý cạnh gói này; mỗi món là một dịch vụ riêng.' },
      freeZone: { label: 'Đuôi tên miền', help: 'Tên miền có đuôi này được tặng kèm gói.' },
      freeMinCycle: { label: 'Khi mua từ', help: 'Mua chu kỳ ngắn hơn thì trả tiền tên miền.' },
      freeOperations: { label: 'Tặng khi', help: 'Đăng ký mới, chuyển về, hoặc cả hai.' },
      freeRenewals: { label: 'Tặng cả khi gia hạn', help: 'Bỏ đánh dấu: chỉ tặng năm đầu.' },
      endPrice: { label: 'Mức giá cần ngừng', help: 'Mức giá đang áp dụng hoặc đã hẹn ngày.' },
      endAt: { label: 'Ngừng từ', help: 'Để trống: ngay bây giờ. Chu kỳ đó không bán được cho tới khi có giá mới.' },
      locationCode: { label: 'Mã', help: 'Chữ thường không dấu, số và dấu gạch ngang, đặt một lần.' },
      locationCity: { label: 'Thành phố', help: 'Hiện cho khách khi họ chọn nơi đặt dịch vụ.' },
      locationActive: { label: 'Đang dùng', help: 'Bỏ đánh dấu: không bán dịch vụ mới ở vị trí này.' },
      stockLocation: { label: 'Vị trí', help: 'Trung tâm dữ liệu chưa bán gói này.' },
      stockMode: { label: 'Tình trạng hàng', help: 'Không giới hạn, theo số lượng, khi máy chủ còn chỗ, hoặc hết hàng.' },
      stockQuantity: { label: 'Số lượng', help: 'Tổng số được bán ở đây.' },
      serverBranch: { label: 'Loại dịch vụ', help: 'Gói thuộc loại dịch vụ này được tạo ở đây.' },
      serverStrategy: { label: 'Máy chủ nào trước', help: 'Cách dịch vụ mới chọn giữa các máy chủ trong nhóm.' },
      serverLocation: { label: 'Vị trí', help: 'Trung tâm dữ liệu của các máy chủ này. Không bắt buộc.' },
      serverModule: { label: 'Module', help: 'Mọi máy chủ của nhóm là kết nối của module này, và mọi gói cấp tại đây dùng nó. Không đổi được khi nhóm đã có máy chủ hoặc gói.' },
      ruleBook: { label: 'Bảng giá', help: 'Giá của một hạng, hoặc giá riêng của một khách hàng.' },
      ruleScope: { label: 'Áp dụng cho', help: 'Cả một nhóm, một sản phẩm, hoặc một gói.' },
      ruleTarget: { label: 'Cụ thể', help: 'Quy tắc cụ thể hơn được dùng trước: gói, rồi sản phẩm, rồi nhóm.' },
      ruleCycle: { label: 'Chu kỳ thanh toán', help: 'Để trống: mọi chu kỳ. Giá cố định thì cho một chu kỳ.' },
      ruleType: { label: 'Cách tính giá', help: 'Giảm theo phần trăm giá khách lẻ, hoặc một giá cố định cho một gói.' },
      ruleValuePercent: { label: 'Mức giảm (%)', help: 'Từ 0 đến 100, trên giá khách lẻ đang áp dụng.' },
      ruleValueAmount: { label: 'Giá (đ, chưa VAT)', help: 'Số đồng cho một chu kỳ.' },
      rulePriority: { label: 'Thứ tự ưu tiên', help: 'Giữa các quy tắc cho cùng một thứ, số nhỏ hơn được dùng. Thường là 100.' },
      ruleFrom: { label: 'Áp dụng từ', help: 'Để trống: ngay bây giờ. Quy tắc đang áp dụng cho cùng thứ đó kết thúc lúc này.' },
      ruleEnd: { label: 'Ngừng từ', help: 'Để trống: ngay bây giờ.' },
      promoScope: { label: 'Mã áp dụng cho', help: 'Tên miền như trước, hoặc một nhóm, một sản phẩm, một gói trong danh mục.' },
      promoTarget: { label: 'Cụ thể', help: 'Chỉ dịch vụ thuộc nhóm, sản phẩm hoặc gói này được giảm.' },
      promoCycles: { label: 'Chu kỳ thanh toán', help: 'Không đánh dấu: mọi chu kỳ.' },
      promoActions: { label: 'Áp dụng khi', help: 'Không đánh dấu: chỉ dịch vụ mới.' },
      promoRecurring: { label: 'Giảm cả các lần gia hạn', help: 'Bỏ đánh dấu: chỉ giảm kỳ đầu.' },
      promoOncePerCustomer: { label: 'Mỗi khách một lần', help: 'Mỗi khách chỉ dùng mã một lần.' },
      promoIncludeSetup: { label: 'Giảm cả phí khởi tạo', help: 'Bỏ đánh dấu: phí khởi tạo trả đủ.' },
      domainOwn: { label: 'Cho dùng tên miền khách đã có', help: 'Khách nhập tên miền của mình cho dịch vụ. Sản phẩm gọi theo tên miền mà tắt mục này thì nhân viên chưa tạo được dịch vụ, vì chưa có giỏ hàng để đăng ký hay chuyển tên miền về.' },
      domainOwnHere: { label: 'Chỉ tên miền đăng ký tại Tino', help: 'Tên miền phải đang được quản lý ở hệ thống này; nhân viên tạo dịch vụ với tên miền khác sẽ bị từ chối.' },
      domainRegister: { label: 'Cho đăng ký tên miền mới', help: 'Khách đăng ký tên miền mới cùng dịch vụ. Có tác dụng khi có giỏ hàng.' },
      domainTransfer: { label: 'Cho chuyển tên miền về', help: 'Khách chuyển tên miền đang ở nơi khác về cùng dịch vụ. Có tác dụng khi có giỏ hàng.' },
      domainTlds: { label: 'Đuôi tên miền được mời', help: 'Cách nhau bằng dấu phẩy, ví dụ vn, com.vn, com. Để trống: mọi đuôi đang bán.' },
      domainSubdomain: { label: 'Tên miền con miễn phí', help: 'Đuôi cấp cho khách, ví dụ .tino.page. Để trống: không cấp. Hiện chỉ lưu, chưa tự cấp.' },
    },
  },
  rules: {
    title: 'Giá theo hạng & giá riêng',
    subtitle: 'Giá trong bảng giá theo hạng và giá riêng của khách hàng: giảm theo phần trăm giá theo hạng hoặc giá khách thường cho một nhóm, một sản phẩm hoặc một gói, hoặc một giá cố định cho một gói. Quy tắc mới thay quy tắc đang áp dụng cho cùng thứ đó kể từ lúc bắt đầu.',
    book: 'Bảng giá',
    allBooks: 'Mọi bảng giá',
    showClosed: 'Hiện cả quy tắc đã ngừng',
    empty: 'Chưa có quy tắc: các bảng giá này bán theo giá khách thường.',
    col: { book: 'Bảng giá', appliesTo: 'Áp dụng cho', cycle: 'Chu kỳ', rule: 'Giá', priority: 'Ưu tiên', when: 'Hiệu lực', reason: 'Lý do' },
    scope: { GROUP: 'Nhóm', PRODUCT: 'Sản phẩm', PLAN: 'Gói' },
    type: { DISCOUNT_PERCENT: 'Giảm theo %', FIXED_PRICE: 'Giá cố định' },
    discount: '−{{value}}%',
    fixed: '{{amount}} đ',
    since: 'từ {{date}}',
    until: 'đến {{date}}',
    add: 'Thêm quy tắc',
    addTitle: 'Quy tắc giá mới',
    end: 'Ngừng',
    endTitle: 'Ngừng quy tắc cho {{target}}',
    fixedNeedsPlan: 'Giá cố định chỉ đặt cho một gói và một chu kỳ.',
    contract: 'Giá riêng của {{name}}',
  },
  promoScope: {
    title: 'Khuyến mãi dịch vụ',
    subtitle: 'Mã khuyến mãi nào giảm giá hosting, máy chủ, email và các dịch vụ khác, với điều kiện gì. Mã đã có người dùng thì giữ nguyên điều kiện: muốn khác thì tạo mã mới.',
    empty: 'Chưa có mã khuyến mãi nào.',
    col: { code: 'Mã', discount: 'Mức giảm', valid: 'Hiệu lực', used: 'Đã dùng', appliesTo: 'Áp dụng cho', terms: 'Điều kiện' },
    scope: { TLD: 'Tên miền', GROUP: 'Nhóm', PRODUCT: 'Sản phẩm', PLAN: 'Gói' },
    action: { NEW: 'Dịch vụ mới', RENEW: 'Gia hạn', UPGRADE: 'Nâng cấp' },
    percent: '−{{value}}%',
    fixed: '−{{amount}} đ',
    used: '{{count}} / {{max}}',
    unlimited: 'không giới hạn',
    edit: 'Đặt phạm vi áp dụng',
    editTitle: 'Mã {{code}} áp dụng cho',
    blocked: {
      disabled: 'Mã đã bị tắt.',
      used: 'Mã đã có người dùng: điều kiện giữ nguyên. Hãy tạo mã mới.',
      domain: 'Mã tên miền (đã gắn đuôi hoặc thao tác) không áp dụng cho dịch vụ được.',
    },
    newOnly: 'Chỉ dịch vụ mới',
    everyCycle: 'mọi chu kỳ',
    recurring: 'giảm cả khi gia hạn',
    firstOnly: 'chỉ kỳ đầu',
    oncePerCustomer: 'mỗi khách một lần',
    includeSetup: 'giảm cả phí khởi tạo',
    disabled: 'Đã tắt',
  },
  reason: 'Lý do',
  save: 'Lưu',
};
